<a
  appHrefNone
  class="icon-main-circle-dark-container"
>
  <span class="flex-content-vc-hc w-37px mr-2" (click)="openCitySearchModal()">
    <i [ngClass]="{'scale-08': navbarTop}" class="icon-v2 search-black-new"></i>
  </span>
</a>
